import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import ArchiveTemplateView from '../share/ArchiveTemplateView';

import { hashHistory } from 'react-router'
import { Spin } from 'antd';

export default class ArchiveReviewClassPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      classId: parseInt(props.params.classId),
      archivePages: [],

      reviewTemplate: {
        isShow: false,
        studentId: null,
        studentName: null,
        pageId: null,
        templateId: null,
        template: null,
        isReviewed: false
      },
      archiveId: null
    };
    // bind this
    this.viewTemplateContent = this.viewTemplateContent.bind(this);
    this.hideTemplateContent = this.hideTemplateContent.bind(this);
    this.onReviewApprove = this.onReviewApprove.bind(this);
    this.onEditPageContent = this.onEditPageContent.bind(this);

    this._templateView = this._templateView.bind(this);
  }

  componentWillMount() {
    this.isReviewApproving = false;
    DataService.getArchiveStatusForClass(this.state.classId, SharedTools.getCurrentSemester(), true).then((response) => {
      this.setState({
        archivePages: response.pages,
        archiveId: response.id
      });
    }, (response) => {
      // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
    }).catch((error) => {
      // catch any error above block ('then' block)
    });
  }

  viewTemplateContent(e) {
    let studentId = parseInt(e.currentTarget.dataset.studentid), studentName = e.currentTarget.dataset.studentname, isReviewed = e.currentTarget.dataset.isreviewed;
    let pageId = parseInt(e.currentTarget.dataset.pageid), templateId = parseInt(e.currentTarget.dataset.templateid)

    this.setState({
      reviewTemplate: {
        isShow: true,
        studentId: studentId,
        studentName: studentName,
        pageId: pageId,
        templateId: templateId,
        isReviewed: isReviewed == 'true'
      }
    });
    // request data
    let template = null;
    DataService.getTemplatesInfo(templateId).then((response) => {
      template = response;
      return DataService.getPageContents(pageId, studentId);
    }, (error) => {}).then((response) => {
      template.areas.forEach((area) => {
        area.question_areas.forEach((question) => {
          response.question_answers.forEach((question_answer) => {
            if (question_answer.question_area_id == question.id) {
              question.answer = question_answer.answer;
            }
          });
        });
      });
      this.state.reviewTemplate.template = template;
      this.setState({
        reviewTemplate: this.state.reviewTemplate
      });
    }, (error) => {});
  }

  hideTemplateContent(e) {
    e.stopPropagation();
    this.setState({
      reviewTemplate: {
        isShow: false,
        studentId: null,
        studentName: null,
        pageId: null,
        templateId: null,
        template: null,
        isReviewed: false
      }
    });
  }

  onClickDoNothing(e) {
    e.stopPropagation();
  }

  onReviewApprove(e) {
    e.stopPropagation();
    if (this.isReviewApproving)
      return;
    let page = this.state.archivePages.find((page) => page.id == this.state.reviewTemplate.pageId);
    if (!page)
      return;
    let student = page.students.find((student) => student.id == this.state.reviewTemplate.studentId);
    if (!student)
      return;

    this.isReviewApproving = true
    DataService.reviewPageContent(student.page_content_id).then((response) => {
      page.reviewed_count += 1;
      student.is_reviewed = true;
      this.setState({
        archivePages: this.state.archivePages,
        reviewTemplate: {
          isShow: false,
          studentId: null,
          studentName: null,
          pageId: null,
          templateId: null,
          template: null,
          isReviewed: false
        }
      });
      this.isReviewApproving = false;
    }, (error) => {
      this.isReviewApproving = false;
    })
  }

  onEditPageContent(e) {
    e.stopPropagation();
    let reviewTemplate = this.state.reviewTemplate;
    hashHistory.push(`archive/record/edit/?studentIds=[${reviewTemplate.studentId}]&pageId=${reviewTemplate.pageId}&templateId=${reviewTemplate.templateId}&archiveId=${this.state.archiveId}`);
  }

  _templateView() {
    if (!this.state.reviewTemplate.isShow)
      return null;

    let template = this.state.reviewTemplate.template, medias = [];
    let width = 450.0, height = template ? (width / template.width * template.height) : 300;
    if (template)
      template.areas.forEach((area) => {
        area.question_areas.forEach((question) => {
          if (question.type == "QuestionAreas::Video")
            medias.push({
              type: 'video',
              answer: question.answer
            });
          else if (question.type == "QuestionAreas::Audio")
            medias.push({
              type: 'audio',
              answer: question.answer
            })
        })
      });
    return (
      <div className="review-template-model" onClick={this.hideTemplateContent}>
        <div className="head">
          <div className="student-name">{this.state.reviewTemplate.studentName}</div>
          <div className="close-button" onClick={this.hideTemplateContent}></div>
        </div>
        {!template && <Spin className="loading-icon" />}
        {template && <div className="content" onClick={this.onClickDoNothing}>
          <ArchiveTemplateView template={template} templateContainerView={{ width: width, height: height }} />
          {medias.length > 0 && <div className="media-container">
            {medias.map((media) => {
              if (media.type == 'video')
                return (
                  <div className="video">
                    <video width="430" controls>
                      <source src={media.answer.url} type="video/mp4" />
                      你的浏览器不支持播放视频
                    </video>
                  </div>);
              else if (media.type == 'audio')
                return (
                  <div className="audio">
                    <audio width="430" controls>
                      <source src={media.answer.url} />
                      你的浏览器不支持播放音频
                    </audio>
                  </div>);
              else
                return null;
            })}
          </div>}
        </div>}
        {template && <div className="actions">
          <div className="edit-btn" onClick={this.onEditPageContent}>去修改</div>
          {!this.state.reviewTemplate.isReviewed && <div className="review-approve-btn" onClick={this.onReviewApprove}>审核通过</div>}
        </div>}
      </div>
    )
  }

  render() {
    return (
      <div className="archive-review-class-page">
        {this.state.archivePages.length <= 0 && <div className="no-content-hint">本班没有需要审核的页面</div>}
        {this.state.archivePages.map((page) =>
          <div className="page-container" key={page.id}>
            <div className="page-info">
              <img className="template-icon" src={SharedTools.getThumbImageUrl(page.template.icon_url)} />
              <span className="template-name">{page.template.title}</span>
              <span className="page-status">待审核{page.students.length - page.reviewed_count - page.unfinished_count}人；已审核{page.reviewed_count}人；未提交{page.unfinished_count}人</span>
            </div>
            <div className="students-container">
              {page.students.filter((student) => student.page_content_id && !student.is_reviewed).map((student) =>
                <div className="student-item clickable" key={student.id} onClick={this.viewTemplateContent} data-studentid={student.id} data-studentname={student.full_name} data-pageid={page.id} data-templateid={page.template.id} data-isreviewed={false}>
                  <div className="name">{student.full_name}</div>
                  <div className="status ready-for-review">待审核</div>
                  <div className="seperater"></div>
                </div>
              )}
            </div>
            <div className="students-container">
              {page.students.filter((student) => student.page_content_id && student.is_reviewed).map((student) =>
                <div className="student-item clickable" key={student.id} onClick={this.viewTemplateContent} data-studentid={student.id} data-studentname={student.full_name} data-pageid={page.id} data-templateid={page.template.id} data-isreviewed={true}>
                  <div className="name">{student.full_name}</div>
                  <div className="status">已审核</div>
                  <div className="seperater"></div>
                </div>
              )}
            </div>
            <div className="students-container">
              {page.students.filter((student) => !student.page_content_id).map((student) =>
                <div className="student-item" key={student.id}>
                  <div className="name">{student.full_name}</div>
                  <div className="status">未提交</div>
                  <div className="seperater"></div>
                </div>
              )}
            </div>
          </div>
        )}
        {this._templateView()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/ArchiveReviewClassPage.jsx